import React, { type ReactNode } from 'react';

export interface CalloutProps {
	title: string;
	subtitle?: string;
	children?: ReactNode;
}

export function Callout({ title, subtitle, children }: CalloutProps) {
	return (
		<div className="rounded-lg border-2 border-dashed border-gray-300 bg-gray-50 py-8 text-center">
			<p className="text-gray-500">{title}</p>
			{subtitle && <p className="mb-4 text-sm text-gray-400">{subtitle}</p>}
			{children}
		</div>
	);
}
